/* eslint-disable */
import _ from 'lodash'

export const QT_ANALYSIS_STATUS = {
  not_started: 'not_started',
  complete: 'complete',
  pending: 'pending',
}

export const QT_CALCULATION_TYPE = {
  manual: 'manual',
  automatic: 'automatic',
  none: 'none',
}

// calculation Types CONST 
export const QT_STATUS_ON_CALCULATION_TYPE = {
  manual: 'Manual Result',
  automatic: 'Algorithm Result',
  none: 'None',
}

export const STATUS_DISCLAIMER = {
  RECORD_ANOTHER_ECG: 'Record Another ECG',
  QT_RESULT_UNAVAILABLE: 'QT Results Unavailable',
  QT_PENDING: 'Pending'
}
// Unreadable,  Too Short, No Analysis - Record Another ECG
// Unclassified, Atrial Fibrillation, Sinus Rhythm with Wide QRS - QT Results Unavailable
export const QT_ALGO_ERROR_RECORD_NEW = {
  unreadable: STATUS_DISCLAIMER.RECORD_ANOTHER_ECG,
  too_short: STATUS_DISCLAIMER.RECORD_ANOTHER_ECG,
  'too short': STATUS_DISCLAIMER.RECORD_ANOTHER_ECG,
  NO_ANALYSIS: STATUS_DISCLAIMER.RECORD_ANOTHER_ECG,
  no_analysis: STATUS_DISCLAIMER.RECORD_ANOTHER_ECG,
  unclassified: STATUS_DISCLAIMER.QT_RESULT_UNAVAILABLE,
  afib: STATUS_DISCLAIMER.QT_RESULT_UNAVAILABLE,
  'sinus_rhythm,wide_qrs': STATUS_DISCLAIMER.QT_RESULT_UNAVAILABLE,
}

// get the data for EK-12 QT, return conditional Status 
export const getAutoEK12QTStatus = (qtAnalysisAlgorithmDetermination, qtAnalysisStatus, qtAnalysisData) => {
  let qtStatus = '';
  let showErrorColor = false;
  let showError = false;

  // Check qt- if - calculationType: automatic | manual | none
  if (qtAnalysisData && qtAnalysisData.calculationType) {
    switch (qtAnalysisData.calculationType) {
      case QT_CALCULATION_TYPE.automatic:
        // condition - when calculationType is automatic, but user has requested for the qt review
        // but not yet reviwed any manual qt value(stil automatic state)
        if(qtAnalysisStatus === QT_ANALYSIS_STATUS.pending){
          qtStatus = STATUS_DISCLAIMER.QT_PENDING
        } else {
          // Check algorithemDetermination
          qtStatus = QT_ALGO_ERROR_RECORD_NEW[qtAnalysisAlgorithmDetermination]
          qtStatus = qtStatus === undefined ? QT_STATUS_ON_CALCULATION_TYPE.automatic : qtStatus
        }
        break;
      case QT_CALCULATION_TYPE.manual:
        // no need to check qtAnalysisAlgorithmDetermination
        // show the updated QT values
        qtStatus = QT_STATUS_ON_CALCULATION_TYPE.manual
        break;
      case QT_CALCULATION_TYPE.none:
        // check qtAnalysisAlgorithmDetermination
        // check status - 
        // not_started means QT as not started or not requested
        // pending - QT is requested
        // completed - QT values submitted from Service provider
        if ((qtAnalysisStatus === QT_ANALYSIS_STATUS.not_started) && qtAnalysisAlgorithmDetermination) {
          // condition where Qt not started yet, KAi gives the AlgorithmDetermination, check and get the disclaimer from QT_ALGO_ERROR_RECORD_NEW
          qtStatus = QT_ALGO_ERROR_RECORD_NEW[qtAnalysisAlgorithmDetermination]
        } else if (qtAnalysisStatus === QT_ANALYSIS_STATUS.not_started && qtAnalysisAlgorithmDetermination === '') {
          // condition where Qt not started yet, AlgorithmDetermination is blank
          qtStatus = STATUS_DISCLAIMER.QT_RESULT_UNAVAILABLE
        } else if (qtAnalysisStatus === QT_ANALYSIS_STATUS.pending){
           // when status is pending, user has requested for the qt review.
          qtStatus = STATUS_DISCLAIMER.QT_PENDING
        } 
        else if (qtAnalysisStatus === QT_ANALYSIS_STATUS.pending && qtAnalysisAlgorithmDetermination === ''
          && qtAnalysisStatus.qt === null && qtAnalysisStatus.qtcb === null && qtAnalysisStatus.qtcf === null && qtAnalysisStatus.rr === null) {
          // condition where Qt is pending, AlgorithmDetermination is blank and all QT values are null - not manual Qt entry is done yet
          qtStatus = STATUS_DISCLAIMER.QT_RESULT_UNAVAILABLE
        }
        break;
      default:
        break;
    }
  }
  // check if object is empty, doesn't return any QT object, display - Record Another ECG
  else if (_.isEmpty(qtAnalysisData)) {
    if(qtAnalysisAlgorithmDetermination && qtAnalysisStatus === QT_ANALYSIS_STATUS.pending){
      qtStatus = STATUS_DISCLAIMER.QT_PENDING
    }
    // if not QT available but has qtAnalysisAlgorithmDetermination
    else if (qtAnalysisAlgorithmDetermination && qtAnalysisStatus === QT_ANALYSIS_STATUS.not_started) {
      qtStatus = STATUS_DISCLAIMER.RECORD_ANOTHER_ECG
    } else if (qtAnalysisAlgorithmDetermination === '') {
      qtStatus = STATUS_DISCLAIMER.QT_RESULT_UNAVAILABLE
    }
  }

  // check and set the showErrorColor / showError
  if (qtStatus === STATUS_DISCLAIMER.QT_RESULT_UNAVAILABLE) {
    showErrorColor = true,
    showError= false
  } else if (qtStatus === STATUS_DISCLAIMER.RECORD_ANOTHER_ECG) {
    showError = true,
    showErrorColor = false
  } else {
    showError = false,
    showErrorColor = false
  }

  return {
    status: qtStatus,
    showErrorColor: showErrorColor,
    showError: showError
  }
}


// WEBPACK FOOTER //
// ./src/legacy/containers/EkgRecordingReviewScreen/Util.js